export default __webpack_public_path__ + "static/media/tatari.5c14f25b.png";